module.exports = __webpack_public_path__ + "img/logo-fifalotto-white4-giant999.32cb4c95.png";